import {REPORT_COACHES_BELOW_RANK} from '/enum/records.enum';

export default {
  reportName: REPORT_COACHES_BELOW_RANK,
};
